import angular from 'angular';


const projectGroupService = angular.module('ttb.services.configuration.projectGroup.service', [])
    .factory('projectGroupService', ['$q', '$http',
        ($q, $http) => {

            const url = '/api/configuration/project-group';

            let items;
            let itemCache = {};

            const clearCache = id => {
                items = null;
                itemCache[id] = null;
            };

            const query = (filter) => {
                const { q } = filter || {};
                return $q((resolve, reject) => {
                    if (items && !filter) {
                        resolve(items);
                        return;
                    }
                    $http.get(url, { params: { q } })
                        .then(response => {
                            if (DEBUG) {
                                console.log(response);
                            }
                            if (!filter) {
                                items = response.data;
                            }
                            resolve(response.data);
                        }, reject);
                });
            }

            const get = ({ id, forceReload }) => {
                return $q((resolve, reject) => {
                    if (!forceReload) {
                        if (itemCache[id]) {
                            resolve(itemCache[id]);
                            return;
                        }
                    }
                    $http.get(`${url}/${id}`)
                        .then(response => {
                            if (DEBUG) {
                                console.log(response);
                            }
                            itemCache[id] = response.data;
                            resolve(itemCache[id]);
                        }, reject);
                });
            }

            const getTemplate = () => {
                return $q((resolve, reject) => {
                    $http.get(`${url}/template`)
                        .then(response => {
                            if (DEBUG) {
                                console.log(response);
                            }
                            resolve(response.data);
                        }, reject);
                });
            }

            const isGroupExists = (groupName, companyId) => {
                return $q((resolve, reject) => {
                    $http.get(`${url}/is-exists`, { params: { companyName: groupName, companyId: companyId } })
                        .then(response => {
                            if (DEBUG) {
                                console.log(response);
                            }
                            resolve(response.data);
                        }, reject);
                });
            }

            const update = (id, { name, description, isActive, workingTimings }) => {
                return $q(function (resolve, reject) {
                    $http.put(`${url}/${id}`,
                        {
                            name,
                            description,
                            isActive,
                            workingTimings,
                        })
                        .then(response => {
                            clearCache(id);
                            resolve(response.data);
                        }, reject);
                });
            };

            const create = (name, description, isActive, workingTimings) => {
                return $q(function (resolve, reject) {
                    $http.post(`${url}`,
                            {
                                name,
                                description,
                                isActive,
                                workingTimings,
                            })
                        .then(response => {
                            resolve(response.data);
                        }, reject);
                });
            };

            return {
                query,
                get,
                update,
                getTemplate,
                isGroupExists,
                create,
                selectedProjectGroup: null
            };
        }])
    .name;

export default projectGroupService;




// WEBPACK FOOTER //
// ../services/configuration/project-group.service.js